import React, { Component, useState } from 'react';
import styles from "./GestioneDuplicatiComponent.module.css";
import PropTypes, { element } from "prop-types";
import Modale from '../../../../../../components/modale/Modale';
import { useEffect } from 'react';
import $ from 'jquery'
import SegnalazioniService from '../../../../../../services/SegnalazioniServices';
import moment from "moment";
import Utils from '../../../../../../utils/Utils';
import OggettiUtili from "../../../../../../utils/OggettiUtili";
import Spinner from '../../../../../../components/spinner/Spinner';

/**
 * @function GestioneDuplicatiComponent component that verifies that duplicates of the report exist and asks for confirmation for its insertion
 * @returns {JSX.Element}
*/
const GestioneDuplicatiComponent = ({ state, props, clickKo }) => {
  const { datiSegnalazione, datiPaziente, callBackPostPaziente, activeFlussoGestioneDuplicati } = state ? state : {};
  const [currentSegnalazione, setCurrentSegnalazione] = useState({});
  const [loading, setLoading] = useState(false);
  const { codiceFiscale, stp } = datiPaziente;
  const { dataSegnalazione, malattia } = datiSegnalazione;

  useEffect(() => {
    if (activeFlussoGestioneDuplicati) {
      if (codiceFiscale || stp) {
        const dataSegnalazioneMoment = moment(Utils.transformDateForBackend(dataSegnalazione));
        let params = {
          malattia: malattia,
          codiceFiscale: codiceFiscale,
          stp: stp,
          dataDa: moment(moment([dataSegnalazioneMoment.year(), dataSegnalazioneMoment.month(), dataSegnalazioneMoment.date()]).subtract(1, 'month').calendar()).format("YYYY-MM-DD"),
          dataA: moment(moment([dataSegnalazioneMoment.year(), dataSegnalazioneMoment.month(), dataSegnalazioneMoment.date()]).add(1, 'month').calendar()).format("YYYY-MM-DD"),
        };
        setLoading(true);
        SegnalazioniService.getSegnalazioni(Utils.removeEmptyValueFromObject(params)).then(res => {
          const segnalazioniList = res?.data?.content;
          setLoading(false);
          if (segnalazioniList?.length) {
            const dataMax = moment.max(segnalazioniList?.map(element => moment(element.dataSegnalazione)));
            const currentSegnalazioneVar = segnalazioniList?.find(element => moment(element.dataSegnalazione).format("YYYY-MM-DD") === dataMax.format("YYYY-MM-DD"));
            $("#modalButton_confermaDatiDupicati").trigger("click");
            setCurrentSegnalazione(currentSegnalazioneVar);
          } else {
            callBackPostPaziente();
          }
        }).catch(reason => {
          setLoading(false);
          console.log("reason", reason)
        })
      } else {
        callBackPostPaziente();
      }
    }
  }, [activeFlussoGestioneDuplicati]);

  /**
  * @function getBody constructs the body of the popup with the information of the last message inserted
  * @returns {JSX.Element}
  */
  const getBody = () => (
    `<div>
            <div class='my-2'>Informiamo che di recente è stata inserita una segnalazione per la stessa malattia associata allo stesso soggetto:</div>
            <div class="mb-1">ID Segnalazione: <b>${currentSegnalazione.idSegnalazione}</b></div>
            <div class="mb-1">ULSS Segnalazione: <b>${OggettiUtili.ulssMap[currentSegnalazione.ulssSegnalazione]?.descrizione}</b></div>
            <div class="mb-1">Data segnalazione: <b>${moment(currentSegnalazione.dataSegnalazione).format("DD-MM-YYYY")}</b></div>
            ${currentSegnalazione?.datiSanitari?.dataInizioSintomi ? `<div class='mb-1'>Data inizio sintomi: <b>${moment(currentSegnalazione.datiSanitari.dataInizioSintomi).format("DD-MM-YYYY")}</b></div>` : ""}  
            <div class='my-2 mb-1'>Si desidera procedere con l'inserimento della segnalazione?</div>
        </div>`
  )

  return (
    <>
      {loading ? (<div><Spinner /></div>) : (<div />)}
      <Modale
        classes="btnBlu"
        typeModal="modalOscura"
        soloModale={true}
        id={"confermaDatiDupicati"}
        name={"conferma dati duplicati"}
        text={"Buttons.conferma"}
        title={"Attenzione"}
        textButtonOk={"Si"}
        style={{ height: "3rem", marginTop: "1rem" }}
        confirmFun={callBackPostPaziente}
        modalText={getBody()}
        textButtonKo={"No"}
        onClickKo={clickKo}
        autoCloseOutside={false}
      />
    </>

  );
};

GestioneDuplicatiComponent.propTypes = {
  state: PropTypes.object.isRequired,
  props: PropTypes.object.isRequired
};

GestioneDuplicatiComponent.defaultProps = {
  state: {},
  props: {}
};

export default GestioneDuplicatiComponent;